module.exports = __webpack_public_path__ + "media/images/flags/4x3/tur-7da678de414cd8abbc652a5ec833ee34.svg";